// FADE TO TOP
var $animation_elements = $('.animated');
var $window = $(window);

function check_if_in_view() {
    var window_height = $window.height();
    var window_top_position = $window.scrollTop();
    var window_bottom_position = (window_top_position + window_height);

    $.each($animation_elements, function() {
        var $element = $(this);
        var element_height = $element.outerHeight();
        var element_top_position = $element.offset().top;
        var element_bottom_position = (element_top_position + element_height);

        //check to see if this current container is within viewport
        if ((element_bottom_position >= window_top_position) &&
            (element_top_position <= window_bottom_position)) {
            $element.addClass('active');
        }
        //else {
        //$element.removeClass('active');
        //}
    });
}

$window.on('scroll resize', check_if_in_view);
$window.trigger('scroll');

$(document).on("sf:ajaxfinish", ".searchandfilter", function(){
	console.log("ajax complete");
	//so load your lightbox or JS scripts here again
  $('.animated').addClass("active");
});

// SCROLL FADE HEADER - Intro
var viewHeight = window.innerHeight;
var header = $(".homepage-image");
$(window).scroll(function (event) {
  var scroll = $(window).scrollTop();
  var calcul = (scroll/500);
  $(".homepage-image").css("opacity",1-calcul);
  //$(".homepage-image .image img").style.transform = 'scale(0.2)';
});


(function() {

    var s = {

        menuState: function() {

            $(this).toggleClass("cross");
            $(".main-nav-wrapper").toggleClass("open");

        },

        headerHeight: function() {

            if ($(window).scrollTop() > 0) {

                return $('.main-header').height();
            } else {

                return $('.main-header').height() - 24;
            }
        },

        headerPosition: function() {

            var top = $(window).scrollTop();

            if (top > 300) {

                $(".main-header").addClass("min");
                $(".sub-nav").addClass("min");
            } else {

                $(".main-header").removeClass("min");
                $(".sub-nav").removeClass("min");
            }
        },

        events: function() {
            $(window).scroll(this.headerPosition);
            $("#btnMobile").on("click", this.menuState);
        },

        init: function() {

            this.headerPosition();
            this.events();
        }

    };

    s.init();

})();

// ## SUB-MENU NAV ########################################
$("ul > li.menu-item-has-children > a").click(function (e) {
    e.preventDefault();
    $("ul li ul").removeClass("active");
    $(this).next(".sub-menu").toggleClass("active");
});

// CLOSE NAV WHEN CLICK ANYWHERE
$(document).on("click", function (event) {
    var $trigger = $(".menu-item-has-children");
    if ($trigger !== event.target && !$trigger.has(event.target).length) {
        $("ul.sub-menu").removeClass("active");
    }
});

// SCROLL TO ANCHOR PRODUCT
$('a.anchor-link').on('click',function (e) {
    console.log('link-#');
    e.preventDefault();

    var target = this.hash,
    $target = $(target);

    $('html, body').stop().animate({
        'scrollTop': $target.offset().top-140
    }, 1200, 'swing', function () {
        //window.location.hash = target;
    });
});

// ## filter ########################################
$(".filter-menu").click(function (e) {
    e.preventDefault();
    $(" .filter-wrapper ").toggleClass("scroll");
});

$(document).ready(function(){
  $('.slideshow .slider-wrapper').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    infinite: true,
    cssEase: 'ease',
    fade: true,
    speed: 1000,
  });
});

// SECTION PRODUITS
$(document).ready(function(){

    $('.products-grid .content').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        nextArrow: $('.next-slick'),
        responsive: [
            {
                breakpoint: 992,
                settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                }
            },
            {
                breakpoint: 576,
                settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                }
            },
        ],
    });

    $('.gallery-photos-wrapper .gallery-wrap').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,

      responsive: [
        {
            breakpoint: 992,
            settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            }
        },
        {
            breakpoint: 768,
            settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            }
        },
        {
            breakpoint: 576,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            }
        },
    ],
    });

    $('.slider-single').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      adaptiveHeight: true,
      draggable: false,
      //asNavFor: '.slider-nav'
  	});
  	$('.slider-nav').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.slider-single',
      focusOnSelect: true,
      nextArrow: $('.next-slick'),
      draggable: false,
  	});

});

$(document).ready(function() {
    var onScroll = function() {
      var scrollTop = $(this).scrollTop();
      $('.parallax-image').each(function(index, elem) {
        var $elem = $(elem);
        $elem.find('img').css('top', scrollTop - $elem.offset().top);
      });
    };
    onScroll.apply(window);
    $(window).on('scroll', onScroll);
});

// ERREUR CAPTCHA
$('.ginput_recaptcha').each(function(i)
{
    var thisID = $(this).attr('id');
    $(this).attr('id', thisID+'_'+i);
});

// SUBMIT AJAX FORM - Page produit
// Ecouter l'événement click de chaque bouton "Envoyer"
$('.modal .gform_button').click(function(event) {
    // Empêcher le comportement par défaut du bouton
    event.preventDefault();

    // Soumettre le formulaire parent du bouton cliqué
    $(this).closest('form').submit();
});
